var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 12c0-1.0609-.4214-2.07828-1.1716-2.82843-.7501-.75014-1.7675-1.17157-2.8284-1.17157s-2.07828.42143-2.82843 1.17157c-.75014.75015-1.17157 1.76753-1.17157 2.82843s.42143 2.0783 1.17157 2.8284c.75015.7502 1.76753 1.1716 2.82843 1.1716s2.0783-.4214 2.8284-1.1716c.7502-.7501 1.1716-1.7675 1.1716-2.8284zm0 0v1.5c0 .663.2634 1.2989.7322 1.7678.4689.4688 1.1048.7322 1.7678.7322s1.2989-.2634 1.7678-.7322c.4688-.4689.7322-1.1048.7322-1.7678v-1.5c0-1.78-.5278-3.52009-1.5168-5.00013-.9889-1.48004-2.3945-2.63359-4.0391-3.31478-1.6445-.68119-3.4541-.85942-5.1999-.51215-1.74584.34726-3.34949 1.20443-4.60816 2.4631s-2.11584 2.86232-2.4631 4.60816c-.34727 1.7458-.16904 3.5554.51215 5.1999.68119 1.6446 1.83474 3.0502 3.31478 4.0391 1.48004.989 3.22013 1.5168 5.00013 1.5168 1.5802.0016 3.1327-.4139 4.5-1.206",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1ad0b8115a1a8506d315213ea6be5b04.svg";
export { ForwardRef as ReactComponent };